import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SortItem } from '../../models/sort-item.model';

@Component({
  selector: '[appSortHeader]',
  templateUrl: './sort-header.component.html',
  styleUrls: ['./sort-header.component.css']
})
export class SortHeaderComponent implements OnInit {

  @Input()
  items: SortItem[] = [];
  @Input()
  activeItem: SortItem = null;

  @Output()
  onSort = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  itemClass(item: SortItem) {
    let cssClass = '';

    if (item.disabled) {
      cssClass += 'sorting_disabled';
    }

    if (!item.disabled && this.activeItem && this.activeItem.code === item.code) {
      cssClass += 'sorting_' + item.sortOrder;
    }

    if (!item.disabled && !this.activeItem) {
      cssClass += 'sorting';
    }

    if (!item.disabled && this.activeItem && this.activeItem.code != item.code) {
      cssClass += 'sorting';
    }

    if (item.class) {
      cssClass += ' ' + item.class;
    }

    return cssClass;
  }

  activate(item: SortItem) {
    if (item.disabled) {
      return;
    }

    if (this.activeItem && this.activeItem.code === item.code) {
      if (this.activeItem.sortOrder === 'asc') {
        this.activeItem.sortOrder = 'desc';
      } else {
        this.activeItem.sortOrder = 'asc';
      }
    } else {
      this.activeItem = item;
    }

    this.onSort.emit(this.activeItem.code + ' ' + this.activeItem.sortOrder);
  }

}
